module.exports = __webpack_public_path__ + "img/undTooth13.5fa094bb.png";